import BaseClass from "../BaseClass.js";

/**
 * FileUpload für Id-Shot und Steuernachweis
 * NICHT für anderes verwenden, wird entfernt, wenn Upload vereinheitlicht
 */
export default class InputFile extends BaseClass {

    constructor(element) {
        super(element);

        this.formUrl = null;
        this.$fileInput = null;
        this.$inputLabel = null;
        this.$deleteButton = null;

        this.changeListener = null;
        this.deleteListener = null;
        this.submitListener = null;

        this.init();

    }

    init() {
        let mySelf = this;

        this.formUrl = this.$element.attr('action');

        let $fileInput = this.$element.find(':file').first();
        if ($fileInput != undefined) {
            this.$fileInput = $fileInput;
        }
        let $inputLabel = this.$element.find('[for=' + $fileInput.attr('id') + ']');
        if ($inputLabel != undefined) {
            this.$inputLabel = $inputLabel;
        }

        this.changeListener = function (event) {
            mySelf.onInput(event);
        }
        this.$fileInput.on('change', this.changeListener);

        let $deleteButton = this.$element.find('.file__delete').first();
        if ($deleteButton != undefined) {
            this.$deleteButton = $deleteButton;
        }
        this.deleteListener = function (event) {
            mySelf.onDelete(event);
        }
        this.$deleteButton.on('click', this.deleteListener);

        this.submitListener = function (event) {
            mySelf.onSubmit(event);
        }
        this.$element.on('submit', this.submitListener);

    }

    onInput(event) {
        event.preventDefault();
        let filename = event.target.files[0].name;
        this.$element.find('.file__file-name').html(filename);
        this.$inputLabel.removeClass('file--initial file--uploaded').addClass('file--selected');
    }

    onDelete(event) {
        event.preventDefault();
        this.$element.find('.file__file-name').empty();
        this.$inputLabel.removeClass('file--selected').addClass('file--initial');
        this.$fileInput.val('');
    }

    onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        let mySelf = this;
        let postData = new FormData(this.$element[0]);

        $.ajax({
            url: this.formUrl,
            type: 'POST',
            data: postData,
            success: function (data) {
                mySelf.$inputLabel.removeClass('file--selected').addClass('file--uploaded');

                if($('#SubmitButton').length > 0) {
                    $('#id-shot-missing').addClass('hidden');
                    $('#id-shot-check').removeClass('hidden');

                    let $submitButton = $('#SubmitButton');

                    $submitButton.addClass('btn--primary');
                    $submitButton.removeClass('bg-gray-e border-color--lightgray');
                    $submitButton.prop('disabled', false);
                }
                mySelf.handleAjaxResponse(data);
            },
            error: function (data) {
                if (data.responseJSON != undefined) {
                    mySelf.addErrors(data.responseJSON.errors);
                }
            },
            processData: false,
            contentType: false
        });
    }

    addErrors(errors) {
        let mySelf = this;

        this.$element.addClass('form-validation-error');

        $.each(errors, function (errorName, errorString) {

            if (mySelf.groupErrors) {
                // Fehler sollen in einem einzigen Container gesammelt angezeigt werden.
                mySelf.showErrorsGroup(errorString);
            } else {
                let $validationElements = mySelf.$element.find('[validation-name="' + errorName + '"]');
                // Es gibt explizit ausgezeichnete Elemente für die Fehlermeldungen
                if ($validationElements.length > 0) {
                    $validationElements.each(function () {

                        if (Array.isArray(errorString)) {
                            errorString = errorString[0];
                        }

                        // nur die erste Fehlermeldung wird anzeigt
                        let options = {title: errorString, customClass: 'error', html: true};
                        let domElement = $(this).get(0);
                        let tooltip = new bootstrap.Tooltip(domElement, options);
                        tooltip.show();
                        setTimeout(function () {
                            tooltip.hide();
                        }, 2000);

                        setTimeout(function () {
                            $(domElement).on('focus', mySelf.disposeValidationTooltipListener);
                        }, 75);
                    });
                } else {
                    const fieldParts = errorName.split('.');

                    let fieldName = fieldParts.shift();

                    for (const fieldPart of fieldParts) {
                        fieldName += '[' + fieldPart + ']';
                    }

                    let $inputElement = mySelf.$element.find(':input[name="' + fieldName + '"], fieldset[name="' + fieldName + '"]').first();

                    // Nichts gesondertes gefunden, direkt am Input die Fehlermeldung anzeigen
                    if ($inputElement.length == 1) {
                        mySelf.addErrorContainer($inputElement, errorName, errorString);
                    } else {
                        mySelf.showErrorsGroup(errorString);
                    }
                }
            }
        });
    }

    showErrorsGroup(errorData) {
        if (this.errorMessagesContainer == null) {
            return;
        }
        let errorString;

        if (Array.isArray(errorData)) {
            errorString = errorData.join("<br/>");
        } else {
            errorString = errorData;
        }

        let errorsHTML = "";
        let currentHTML = this.errorMessagesContainer.html();
        if (currentHTML.length > 0) {
            errorsHTML = currentHTML + "<br/>" + errorString;
        } else {
            errorsHTML = errorString;
        }
        this.errorMessagesContainer.html(errorsHTML);

        if (this.errorMessagesContainer.hasClass("hidden")) {
            this.errorMessagesContainer.removeClass('hidden');
        }
    }

    addErrorContainer($inputElement, errorName, errorString) {
        let $errorContainer = this.templatesWorker.getTemplate('form_validation_error_tpl');
        $errorContainer.attr('id', 'errorContainer_' + errorName);
        $errorContainer.attr('for', errorName);
        $errorContainer.find('[data-type="message"]').html(errorString);

        $inputElement.after($errorContainer);

        $inputElement.on('click', function () {
            $errorContainer.remove();
        });
        $errorContainer.on('click', function () {
            $errorContainer.remove();
        });
        $inputElement.on('focus', function () {
            $errorContainer.remove();
        });

        setTimeout(function(){
            $errorContainer.remove();
        },10000);

    }

    onErrorAdd(event, data) {
        this.addErrors(data.errors);
    }


    destroyListener() {
        this.$fileInput.off('change', this.changeListener);
        this.$deleteButton.off('click', this.deleteListener);
        this.$element.off('submit', this.submitListener);
    }
}